import { render } from "./container-header.vue?vue&type=template&id=06cadbe1&scoped=true&ts=true"
import script from "./container-header.vue?vue&type=script&lang=ts"
export * from "./container-header.vue?vue&type=script&lang=ts"

import "./container-header.vue?vue&type=style&index=0&id=06cadbe1&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cadbe1"]])

export default __exports__